import React from 'react'
import {Form, Button,DatePicker, Select,} from 'antd';
import GetClient from '../client/GetClient'
import dayjs from 'dayjs';
import GetGroupNum from '../ledger/GetGroupNum';
import GetUserDept from '../../cpn/GetUserDept';
const { RangePicker } = DatePicker;
function ArapQuery(props) {
    const [form] = Form.useForm();
    return (
        <Form 
            form={form}
            layout="inline"
            name="form_in_modal"
            initialValues={{                        
                // eie_arrive_date_s:[
                //     localStorage.getItem('arapWait_query_arrive_date_s')?localStorage.getItem('arapWait_query_arrive_date_s'):'',
                //     localStorage.getItem('arapWait_query_arrive_date_e')?localStorage.getItem('arapWait_query_arrive_date_e'):''
                // ],
                // ebn_date_s: localStorage.getItem('arapWait_query_date_s')?localStorage.getItem('arapWait_query_date_s'):'',
                // ebn_date_e: localStorage.getItem('arapWait_query_date_e')?localStorage.getItem('arapWait_query_date_e'):'',
                // ebn_team_num:localStorage.getItem('arapWait_query_team_num'),
                // eie_dept_id:localStorage.getItem('arapWait_query_dept'),
                // ysyf_type:localStorage.getItem('arapWait_query_ysyf_type'),
                // eie_client_id:localStorage.getItem('arapWait_query_client')?localStorage.getItem('arapWait_query_client'):"",
            }}
            onFinish={(values) => {
                console.log(values);
                    props.getQuery({
                        action:"search",
                        ebn_date_s:values.ebn_date?dayjs(values.ebn_date[0]).format('YYYY-MM-DD'):'',
                        ebn_date_e:values.ebn_date?dayjs(values.ebn_date[1]).format('YYYY-MM-DD'):'',
                        eie_dept_id:values.eie_dept_id,
                        eie_client_id:values.eie_client_id,
                        ebn_team_num:values.ebn_team_num,                                
                        ysyf_type:values.ysyf_type,                                
                    })
                    localStorage.setItem('arapWait_query_dept',values.eie_dept_id)
                    localStorage.setItem('arapWait_query_client',values.eie_client_id)
                    localStorage.setItem('arapWait_query_team_num',values.ebn_team_num)
                    localStorage.setItem('arapWait_query_ysyf_type',values.ysyf_type)
                    localStorage.setItem('arapWait_query_date_s',values.ebn_date?dayjs(values.ebn_date[0]).format('YYYY-MM-DD'):'')
                    localStorage.setItem('arapWait_query_date_e',values.ebn_date?dayjs(values.ebn_date[1]).format('YYYY-MM-DD'):'')
                    localStorage.setItem('arapWait_query_action','search')
            }}
        >
            <GetClient 
                label='客户'  
                name='eie_client_id' 
                style={{width:'250px'}}
                getClient={(e) => {}} 
                FormStyle={{marginBottom:"0",width:"270px"}}
                setClient={true}
                labelCol={{span:3}}
                initialValues={props.query.eie_client_id}
            />   
            <Form.Item 
                name='ebn_date' 
                label='出发日期'
                labelCol={{span:6}} 
                style={{width:'300px'}}
            >                                    
                <RangePicker />
            </Form.Item>
            <GetGroupNum 
                label='团号' 
                wrapperCol={{span:19}} 
                getGroupNum={(e) => {}}
                name='ebn_team_num'
                initialValues={localStorage.getItem('arapWait_query_team_num')}
                FormStyle={{width:'170px'}}
                
            />
           <GetUserDept  
                label='部门' 
                wrapperCol={{span:19}}
                getUserDept={(e) => {}}
                name='eie_dept_id'
                selectAll='true'
                initialValues={localStorage.getItem('arapWait_query_dept')}
                style={{width:"120px"}}
                setDept={true}
                labelCol={{span:8}}
                FormStyle={{width:"170px"}}
                value={props.eie_dept_id}
            />
            <Form.Item 
                name='ysyf_type' 
                label='类型' 
                style={{width:"110px"}}
                wrapperCol={{span:15}}
                labelCol={{span:9}}
            >                                    
                <Select
                    value={props.query.ysyf_type}
                    style={{width:"80px"}}
                    options={[       
                        {
                            value:"",
                            label:'全部',
                        },
                        {
                            value:"2",
                            label:'收入',
                        },
                        {
                            value:"1",
                            label:'支出',
                        },        
                    ]}
                />
            </Form.Item>
            <Form.Item
                style={{width:"60px"}}
            >
                <Button
                    htmlType='submit'
                >查询</Button>
            </Form.Item>
            <Form.Item
                style={{width:"60px"}}
            >
                <Button
                    onClick={() => {                                                  
                        localStorage.setItem('arapWait_query_dept','')
                        localStorage.setItem('arapWait_query_client','')
                        localStorage.setItem('arapWait_query_team_num','')
                        localStorage.setItem('arapWait_query_date_s','')
                        localStorage.setItem('arapWait_query_date_e','')
                        localStorage.setItem('arapWait_query_action','')
                        localStorage.setItem('arapWait_query_ysyf_type','')
                        props.getQuery({action:'',ysyf_type:'',eie_client_id:'',eie_arrive_date_s:'',ebn_team_num:'',eie_dept_id:'',ebn_date_s:''})                                    
                        form.resetFields();        
                    }}
                >重置</Button>
            </Form.Item>
        </Form>
    )
}

export default ArapQuery